import { FormGroup } from '@angular/forms';
import { RegistrationCodeForm } from './registration-code-form.interface';

export type RegistrationCodeFormValue = ReturnType<
  FormGroup<RegistrationCodeForm>['getRawValue']
>;
